// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback} from 'react';
import cn from 'classnames';
import {Text} from '../../comp/text';
import {Money} from '../../comp/money';
import {Icon} from '../../comp/icon';
import {OFFER_KIND_META, OFFER_STATUS} from '../../utils/constants.js';
import {Cover} from './cover.js';
import * as cns from './item.module.less';

function Status({status}){
    let ico = null;
    if (status==OFFER_STATUS.IN_PROGRESS)
        ico = 'refresh';
    else if (status==OFFER_STATUS.COMPLETED)
        ico = 'check';
    if (!ico)
        return null;
    return <div className={cns.status}>
      <Icon ico={ico} size="m"/>
    </div>;
}

export function Item({data, on_click, has_overlay=true}){
    const handle_click = useCallback(()=>
        on_click?.(data), [data, on_click]);
    const c_name = OFFER_KIND_META[data.category]?.item_name || data.category;
    return <button className={cn(cns.root, has_overlay&&cns.root__overlayable)}
      onClick={handle_click}>
      <Status status={data.status}/>
      <Cover data={data} img_class={cns.img} overlay_class={cns.overlay}
        action_class={cns.action} platforms_class={cns.platforms}
        className={cns.cover} lazy has_overlay={has_overlay}/>
      <Text.xxxs className={cns.category} span secondary>
        {c_name}
      </Text.xxxs>
      <Text.s className={cns.name} span>{data.name}</Text.s>
      <Money className={cns.payout} size="s">{data.payout}</Money>
    </button>;
}
